import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    event.preventDefault()
    const open = this.element.classList.toggle("menu-open")
    event.currentTarget.setAttribute("aria-expanded", open)
    document.body.classList.toggle("overflow-hidden", open)
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }
}
